// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"2a79e165","198":"2ef7a0bb","201":"3a724300","233":"f7bec20b","245":"70eb64f8","379":"bae92fef","391":"1ca6b74a","446":"5eb3cf3c","467":"1dab107c","496":"faa9ad39","510":"48f6bfb1","623":"deaad5f8","705":"b5c5c9de","736":"85758b72","830":"c2be2297","848":"ad8180f2"}[chunkId] + ".chunk.js";
};